import AnalysisCollection from "@/collections/lab/AnalysisCollection";
import InstrumentCollection from "@/collections/lab/InstrumentCollection";
import InstrumentModel from "@/models/lab/InstrumentModel";
import LabServiceModel from "@/models/LabServiceModel";
import PrepProcessModel from "@/models/lab/PrepProcessModel";

export default class PrepTaskModel extends LabServiceModel {
  modelName() {
    return "prep-task";
  }
  isPrep() {
    return true;
  }
  icon() {
    return "vial";
  }
  schedulableTaskType() {
    return "App\\Models\\PrepTask";
  }
  defaults() {
    return {
      id: null,
      prep_process_id: null,
      prep_process: null,
      instrument_id: null,
      instrument: null,
      name: null,
      description: null,
      order: 0,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      prep_task_analyses: [],
      analyses: [],
      instruments: [],
    };
  }
  mutations() {
    return {
      id: (val) => this.nullStringMutator(val),
      prep_process_id: (val) => this.nullStringMutator(val),
      instrument_id: (val) => this.nullStringMutator(val),
      name: (val) => this.nullStringMutator(val),
      description: (val) => this.nullStringMutator(val),
      order: (val) => this.nullNumberMutator(val),
      created_at: (val) => this.nullStringMutator(val),
      updated_at: (val) => this.nullStringMutator(val),
      deleted_at: (val) => this.nullStringMutator(val),
    };
  }
  validation() {
    return {};
  }
  getPrepProcess() {
    return this.getRelatedModel(PrepProcessModel, "prep_process");
  }
  getInstrument() {
    return this.getRelatedModel(InstrumentModel, "instrument");
  }
  getInstruments() {
    return this.getRelatedCollection(new InstrumentCollection(), "instruments");
  }
  getAnalyses() {
    return this.getRelatedCollection(new AnalysisCollection(), "analyses");
  }
}
